function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Fill 1");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Final",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("g", {
  id: "Manage-User-Permissions:-SuperUser-Home",
  transform: "translate(-1123.000000, -305.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1131.09922,307.465305 C1132.07804,307.465305 1132.86008,308.247474 1132.86008,309.226169 C1132.86008,310.204864 1132.07804,310.987033 1131.09922,310.987033 C1130.1204,310.987033 1129.33835,310.204864 1129.33835,309.226169 C1129.33835,308.247474 1130.1204,307.465305 1131.09922,307.465305 L1131.09922,307.465305 Z M1131.09922,306.408723 C1129.5495,306.408723 1128.28177,307.676294 1128.28177,309.226169 C1128.28177,310.775887 1129.54934,312.043615 1131.09922,312.043615 C1132.64894,312.043615 1133.91666,310.776044 1133.91666,309.226169 C1133.91666,307.676451 1132.64909,306.408723 1131.09922,306.408723 Z M1131.09922,306.056582 C1133.97549,306.056582 1136.48715,307.32846 1137.99394,309.226137 C1136.48658,311.121991 1133.97351,312.395693 1131.09922,312.395693 C1128.22454,312.395693 1125.7116,311.12196 1124.20449,309.226137 C1125.7116,307.328429 1128.22303,306.056582 1131.09922,306.056582 Z M1131.09922,305 C1127.74226,305 1124.78275,306.548114 1123.09829,308.917923 C1122.97277,309.095047 1122.96182,309.338487 1123.09829,309.528755 C1124.78287,311.898595 1127.74226,313.452023 1131.09922,313.452023 C1134.45618,313.452023 1137.41569,311.898375 1139.10014,309.528755 C1139.23463,309.35641 1139.2318,309.090268 1139.10014,308.917923 C1137.41556,306.548083 1134.45618,305 1131.09922,305 Z",
  id: "Fill-1"
})));

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "9px",
    viewBox: "0 0 17 9",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.403aaa5f.svg";
export { ForwardRef as ReactComponent };